var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllAgendaWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ill_agenda",
    "data-name": "ill agenda",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274,
    height: 159,
    viewBox: "0 0 274 159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28410",
    "data-name": "Path 28410",
    d: "M0,0H274V159H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28310",
    "data-name": "Path 28310",
    d: "M188.573,234.218c-10.571-.1-21.12,1.032-31.7.556a4.189,4.189,0,0,0-2.458-.3q-17.493-.019-34.983,0a4.183,4.183,0,0,0-2.458.3c-11,.5-21.969-.742-32.964-.579-15.3-1.039-30.642-1.577-45.886-3.3C27.29,229.678,16.4,228.547,5.9,225.323,3.48,224.578-.058,224.19,0,221.1c.055-2.8,3.429-3.319,5.814-4,3.415-.971,6.894-1.714,10.344-2.555a2.418,2.418,0,0,1,3.342-.712,1.755,1.755,0,0,1,.007,2.079,2.771,2.771,0,0,1-1.032.457c-.614.159-1.249.193-2.128.365,2.556,1.168,5.179,1.076,7.583,1.193,8.838.43,17.665,1.1,26.512,1.376,26.99.829,53.986.574,80.981.634a27.22,27.22,0,0,1,5.355.415,2.8,2.8,0,0,1,2.04,2.291c.038.868-.841,1.065-1.53,2.019a182.491,182.491,0,0,0,30.224-.215c-1.09-.8-2.385-.42-2.672-1.534a3.3,3.3,0,0,1,2.207-3.157,105.715,105.715,0,0,1,14.406-.382,8.2,8.2,0,0,1,2.06.384,11.185,11.185,0,0,1,3.24,1.763c.565.476,1.084,1.059.156,1.719-3.164,1.1-6.446.827-9.708.91,6.272.089,12.528.756,18.79.821,15.2.16,30.4.1,45.6.028,5.343-.023,10.645-.9,15.992-1.029.159,0,.262-.293.3-.514.191-1.868,1.353-3.406,1.741-5.207.41-1,.26-2.211,1.161-3.019a35.706,35.706,0,0,1,10.53,3.176c1.188.584,2.768,1.2,2.674,2.805-.094,1.631-1.544,2.337-2.956,2.926a71.724,71.724,0,0,1-16.787,4.273A420.488,420.488,0,0,1,207.793,233c-6.412.276-12.814.807-19.22,1.222",
    transform: "translate(0 -78.573)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28311",
    "data-name": "Path 28311",
    d: "M372.669,211.577c-.192,1.072.194,2.24-.544,3.219-1.857.965-3.892.847-5.875.857-15.044.075-30.09.107-45.134-.018-3.98-.033-7.952-.691-11.953-.6-.654-.118-.9-.616-1.1-1.161.295-3.408-2-6.137-2.479-9.35a13.213,13.213,0,0,1,10.089-.035q24.04.032,48.079.063c6.514.007,6.952.32,8.846,6.454a1.125,1.125,0,0,0,.07.569",
    transform: "translate(-111.878 -74.918)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28312",
    "data-name": "Path 28312",
    d: "M61.078,19.1l5.209.2c-.493,1.4-1.067,2.727-2.641,3.255a5.417,5.417,0,0,0-3.449-.446c-1.689.734-1.578,2.448-1.881,3.785-3.3,14.554-6.787,29.065-10.166,43.6q-4.961,21.343-9.917,42.688-2.33,9.981-4.713,19.95c-.351,1.457-.563,3.156-2.813,2.059l.018,0c-2.023-1.748-1.566-3.984-1.12-6.147,1.719-8.334,3.933-16.555,5.79-24.857,4.355-19.467,9.233-38.814,13.546-58.291,1.43-6.458,3.1-12.864,4.652-19.293.737-3.043,2.032-5.771,5.649-6.352l1.836-.149",
    transform: "translate(-10.698 -7.03)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28313",
    "data-name": "Path 28313",
    d: "M58.238,19.324C54.172,21.1,53.561,24.975,52.7,28.6Q46.347,55.289,40.126,82c-3.6,15.465-7.086,30.956-10.724,46.412a11.022,11.022,0,0,0,.319,5.849c-2.427,0-3.673-1.385-3.1-3.972,1.725-7.838,3.636-15.636,5.419-23.462,1.6-7.019,3.211-14.045,4.889-21.034,2.312-9.628,4.444-19.3,6.894-28.9Q47.955,40.7,51.246,24.311c1.349-3.03,3.321-5.193,6.992-4.987",
    transform: "translate(-9.695 -7.109)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28314",
    "data-name": "Path 28314",
    d: "M184.54,246.834c.726-.869,1.731-.6,2.642-.6q17.307-.022,34.614,0c.912,0,1.916-.266,2.641.6h-39.9",
    transform: "translate(-67.562 -90.632)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28315",
    "data-name": "Path 28315",
    d: "M240.572,131.964c.829,3.182,1.748,6.344,2.459,9.552.544,2.453-1.142,3.561-3.105,4.363a3.479,3.479,0,0,1-1.675.712,11.774,11.774,0,0,1-3.772.291c-12.988-.079-25.976-.016-38.961-.1-.39.007-.784,0-1.174,0-23.512-.007-47.028.06-70.542.027-6.845-.01-8.981-1.583-10.573-8.326-5.6-23.738-11.128-47.495-16.73-71.233-.894-3.786-1.759-7.577-2.569-11.381-.283-1.33-.722-2.666.036-3.993,1.057-1.182,2.492-1,3.838-1q60.066-.037,120.132-.008c1.258,0,2.551-.088,3.617.8,2.559,6.34,3.124,13.191,5.071,19.688a24.925,24.925,0,0,1,3.2,13.274,10.659,10.659,0,0,0,1.169,5.024c2.1,3.473,2.344,7.486,3.325,11.286a5.755,5.755,0,0,1-.183,1.47q.422,2.541.845,5.081a5.82,5.82,0,0,1,1.2,1.968,49.554,49.554,0,0,1,2,8.7,5.981,5.981,0,0,1-.216,1.847c.441,2.979,2.01,5.713,1.933,8.805-.92.167-1.858.183-2.779.4-1.059.254-2.1-.185-2.144-1.264-.1-2.74-2.262-3.4-4.1-4.44.558-3.459-.882-6.571-1.75-9.772-.306-1.125-1.32-1.5-2.432-1.695-7.044-1.216-7.985-.229-6.5,6.738.32,1.5.961,3.028.247,4.607a15.443,15.443,0,0,1-10.106.667c-.721-1.571.721-1.48,1.445-1.653,1.627-.388,1.973-1.35,1.634-2.8-.1-.408-.186-.817-.278-1.226-1.464-6.512-1.668-6.668-8.369-6.391-3,.124-3.341.672-2.662,3.73.539,2.43,1.628,4.764,1.391,7.345-2.1,2.091-4.227,1.8-6.383.1-1.227-2.474-1.131-5.272-1.916-7.873-.722-2.395-2.02-3.32-4.514-3.339-6.606-.051-6.651-.05-5.116,6.34.4,1.685,1.277,3.356.547,5.178-1.889,1.652-3.983,1.38-6.125.66-1.017-2.632-1-5.486-1.746-8.189-.925-3.334-1.47-3.866-5.008-3.942-6.5-.14-6.41-.159-4.828,6.178.621,2.49,1.447,4.331,4.407,4.345.657,0,1.516.323,1.209,1.4-1.958,1.245-4.1.545-6.171.58-1.678.028-2.416,1.24-1.168,2.114,3.883,2.72,2.832,6.667,3.133,10.313.017.21.013.42.018.631.142,5.72.265,5.07,5.915,6.133,4.806.9,9.157-.765,13.734-.606,3.567.124,7.189-.364,10.614,1.1a.576.576,0,0,0,.311.047c7.983-.736,16.008.119,23.959-.448,3.884-.277,7.761.236,11.647-.4,2.288-.375,3.154-1.2,3.035-3.394a29.881,29.881,0,0,1,.263-5.351c.13-1.026.036-2.158,1.26-2.673",
    transform: "translate(-34.247 -18.722)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28316",
    "data-name": "Path 28316",
    d: "M218.935,39.107q-62.241,0-124.482.015c-.978,0-2.134-.505-2.918.592a.551.551,0,0,1-.892-.071,154.6,154.6,0,0,1-4.17-17.451A3.76,3.76,0,0,1,87.8,18.523c3.22-1.7,6.729-.46,10.064-.982,1.4-.965,2.993-.747,4.551-.744,3.831-.077,7.663-.106,11.492.014,1.206.126,2.738-.112,3.182,1.34.471,1.537-.441,2.759-1.661,3.693-.715.512-2.027.344-1.99,1.73,2.231,3.108,3.321,2.857,5.653-1.31,1.18-1.566.966-3.885,2.779-5.109a35.814,35.814,0,0,1,11.143.07c1.516,1.23.853,2.447-.02,3.662-.874.843-2.442,1.023-2.534,2.621-.032,1.425.863,2.071,2.066,2.448.934.287,1.312-.315,1.627-1.02.494-1.01,1.346-1.779,1.835-2.788,1.065-1.395.685-3.554,2.435-4.584l25.391-.04c1.4-.972,2.988-.706,4.535-.723,4.032-.076,8.063-.123,12.093.033a4.461,4.461,0,0,1,2.121.463c1.634,1.915.3,3.336-.8,4.793-.647.5-1.931.237-1.9,1.564.063,1.394.991,1.978,2.171,2.32,1.4.327,1.73-.739,2.167-1.662.382-.812.908-1.54,1.271-2.361,1.22-1.5.409-4.187,2.9-4.947a51.056,51.056,0,0,1,10.987.138c2.319,2.791-.418,4.156-1.682,5.937-.6.473-1.132.974-.508,1.791a1.644,1.644,0,0,0,2.219.494,6.184,6.184,0,0,0,2.668-2.948c1.052-1.431,1.113-3.355,2.346-4.693,1.26-.029,2.521-.086,3.781-.082,4.468.015,6.378,1.351,7.433,5.611,1.2,4.864,2.191,9.782,3.273,14.676a1.363,1.363,0,0,1-1.17-.1,16.372,16.372,0,0,0-4.41-.27q-49.094-.014-98.188,0a17.5,17.5,0,0,0-4.411.269c-5.149.36-10.322-.281-15.431.35a3.172,3.172,0,0,1-.593.019c-.053,0,.067.085.363.018a13.618,13.618,0,0,1,2.821-.293c39.018-.5,78.039-.166,117.058-.258a6.612,6.612,0,0,1,3.942.886,1.4,1.4,0,0,1,.068.556",
    transform: "translate(-31.631 -6.159)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28317",
    "data-name": "Path 28317",
    d: "M238.513,164.829c1.919.564,3.838.957,5.752-.02,2.352-.4,4.7-.73,6.887.637l10.216-.64c3.652-1.343,7.179-.575,10.68.627,2.276-.6,4.091-.078,4.315,2.494.2,2.3.835,3.118,3.036,1.832.788-.46,1,.534,1.529.742a5.159,5.159,0,0,1,.68,3.149,37.053,37.053,0,0,0-.61,9.9c.051,1.692-.8,2.213-2.212,2.416-4.638.664-9.3-.056-14.018.761-4.2.729-8.709-.115-13.066-.454-3.091-.24-6.1,1.227-9.092.6a59.193,59.193,0,0,0-13.026-1.257c-2.15.027-4.07,1.127-5.993,1.17-3.9.087-7.815-.655-11.728-1-1.49-.131-1.915-.9-1.89-2.292.061-3.329-.016-6.66.02-9.99.015-1.333-.055-2.532-1.537-3.118a3.275,3.275,0,0,1-2.009-1.892c-.312-.845-1.3-1.688-.546-2.584a2.577,2.577,0,0,1,2.594-.8c2.195.646,4.407.217,6.606.337a4.618,4.618,0,0,1,5.608-.009c2.151-.126,4.375.5,6.429-.62a34.8,34.8,0,0,1,11.376.018",
    transform: "translate(-75.281 -60.41)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28318",
    "data-name": "Path 28318",
    d: "M92.151,53.07a1.122,1.122,0,0,0,.516-.02c2.123,9.289,4.208,18.588,6.377,27.867q6.9,29.539,13.886,59.061c1.243,5.267,3.018,6.657,8.289,6.66q35.792.02,71.585.036c-.167,1.636-1.46.854-2.188.873-3.68.1-7.365.044-11.047.052,4.066.018,8.134.046,12.2-.029.586-.011,1.784.6,1.7-.89l43.691.049a.793.793,0,0,1,.05,1.209l-.65,1.129c-3.351.4-6.815-.8-10.09.7-1.116.607-2.2.114-3.306-.068-5.792-.416-11.589-.074-17.381-.145-3.268-.04-6.538-.095-9.808-.046q-9.316.108-18.629-.046c-1.345.11-2.693.028-4.04.054-18.448-.091-36.9,0-55.346-.061-4.628-.016-7.124-2.126-8.2-7.088-2.153-9.952-4.587-19.837-6.907-29.748-4.21-17.985-8.284-36-12.71-53.935-.37-1.5-1.017-3.021-.406-4.628a1.925,1.925,0,0,1,2.411-.988",
    transform: "translate(-32.763 -19.495)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28319",
    "data-name": "Path 28319",
    d: "M138.691,14.9a3.763,3.763,0,0,0,1.33-3.345A5.265,5.265,0,0,1,138.847,9.4a6.423,6.423,0,0,0-8.172-3.715c-1.479.451-2.314,1.322-2.127,2.957a3.444,3.444,0,0,1-.555,2.95,8.2,8.2,0,0,1-1.8,5.068,4.224,4.224,0,0,1-5.862.59c-.382-.854.229-1.31.733-1.81,1.8-.239,2.027-1.832,2.118-3.037.108-1.44-1.485-.555-2.194-1.008a1.351,1.351,0,0,1-.542-1.084c.176-1.934.361-3.882-2.1-4.553A6.612,6.612,0,0,0,111.621,7.2c-1.284,1.193-1.528,2.965-2.685,4.19l-4.47.022c-.718-7.565,7.985-14,16.447-10.208a7.331,7.331,0,0,0,6.877.009c7.585-3.367,15.847,1.2,16.731,8.411a12.207,12.207,0,0,0,.5,1.81c-.721,1.694-.531,3.734-1.971,5.155-1.75,1.516-3.6,2.174-5.694.641-.548-1.338.4-1.83,1.331-2.329",
    transform: "translate(-38.231 -0.032)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28320",
    "data-name": "Path 28320",
    d: "M322.439,112.241l23.332-.127c1.216-.006,2.278.1,2.57,1.655.617,3.283,1.783,6.455,2.024,9.817a4.936,4.936,0,0,1-2.084.694c-7.661.155-15.326.586-22.978-.214a17.161,17.161,0,0,1-2.863-11.825",
    transform: "translate(-118.011 -41.273)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28321",
    "data-name": "Path 28321",
    d: "M213.007,11.367l-4.482,0c-.135-4.458,2.047-7.529,5.8-9.674,4.362-2.491,8.69-2.038,12.808.434,1.235.742,1.824,1.106,3.18.115,3.809-2.783,8.067-2.861,12.212-.848s6.7,5.3,6.583,10.173a8.693,8.693,0,0,1-1.837,5.11c-2.623,1.943-3.838,1.948-5.717.022a7.772,7.772,0,0,0,2.951-5.027,15.749,15.749,0,0,1-1.523-2.72,6.769,6.769,0,0,0-8.571-3.075c-2.187.839-1.706,2.577-1.824,4.175-.051.849-.965,1.325-.948,2.215.024,1.192-.4,1.924-1.772,1.948s-1.751-.773-1.888-1.9a1.143,1.143,0,0,0-.482-.75l-1.96-.2c-1.091-.437-.86-1.369-.677-2.139.565-2.386-.823-3.221-2.772-3.659-3.535-.795-5.81.234-7.6,3.434a7.37,7.37,0,0,1-1.484,2.376",
    transform: "translate(-76.341 0)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28322",
    "data-name": "Path 28322",
    d: "M315.96,84.267c5.9-.006,11.809.052,17.712-.052,1.948-.034,2.875.651,3.225,2.559.451,2.466,1.1,4.9,1.719,7.33.539,2.107-.242,2.829-2.382,2.793-5.9-.1-11.807-.05-17.711-.059-2.541-3.374-2.708-7.463-3.415-11.383-.1-.547.4-.911.853-1.187",
    transform: "translate(-115.359 -31.002)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28323",
    "data-name": "Path 28323",
    d: "M344.32,140.471c1.866,3.716,2.183,7.845,3.17,11.8-4.866.869-9.773.144-14.654.371-.839-.164-1.848-.324-2.107-1.186-.984-3.276-2.782-6.407-2.016-10.036.816-1.219,2.075-.693,3.152-.737,4.149-.167,8.308.225,12.455-.208",
    transform: "translate(-120.278 -51.712)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28324",
    "data-name": "Path 28324",
    d: "M311.709,83.932c-.222,4.409,1.769,8.368,2.562,12.571l-7.589.075q-1.6-6.637-3.2-13.274c2.665,1.2,5.49.334,8.225.629",
    transform: "translate(-111.109 -30.667)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28325",
    "data-name": "Path 28325",
    d: "M318.06,112.3q1.3,5.662,2.6,11.324a.759.759,0,0,1-.333.974c-2.449.435-4.885.64-7.255-.389q-1.347-5.971-2.693-11.942l7.686.033",
    transform: "translate(-113.631 -41.328)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28326",
    "data-name": "Path 28326",
    d: "M221.518,49.89q.3,0,.591,0c-.007.207-.013.415-.02.623H95.214c-.006-.209-.012-.418-.018-.627h3.4a3.016,3.016,0,0,1,1.838-.3c39.78-.6,79.562-.245,119.343-.3a2.794,2.794,0,0,1,1.746.6",
    transform: "translate(-34.852 -18.124)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28327",
    "data-name": "Path 28327",
    d: "M89.616,40.722a2.511,2.511,0,0,1-1.97.706,2.484,2.484,0,0,1-1.555-2.161c-1.019-5.186-2.719-10.218-3.528-15.454a1.686,1.686,0,0,1,.748-1.35,4.962,4.962,0,0,1,2.5-3.05,2.09,2.09,0,0,1,.581.1c-1.486,3.924.52,7.5,1.187,11.193.6,3.351,1.8,6.587,2.032,10.018",
    transform: "translate(-30.227 -7.147)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28328",
    "data-name": "Path 28328",
    d: "M314.623,130.973l7.576.054a204.379,204.379,0,0,1,25.309.03c-.244.617-.846.552-1.337.694-10.1.4-20.208.3-30.312.047l-.787-.012-.449-.813",
    transform: "translate(-115.187 -48.097)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28329",
    "data-name": "Path 28329",
    d: "M351.884,130.9l-25.309-.03c0-.213.007-.426.011-.639l25.33.021-.032.647",
    transform: "translate(-119.563 -47.944)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28330",
    "data-name": "Path 28330",
    d: "M329.384,158.706a121.9,121.9,0,0,0,15.186-.1c-.874,1.156-2.136.681-3.232.689-6.755.049-13.511.035-20.267.043a1.21,1.21,0,0,1-.447-1.4c2.975-.36,5.93-.5,8.76.771",
    transform: "translate(-117.357 -58.049)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28331",
    "data-name": "Path 28331",
    d: "M342.386,140.255c-.152.957-.783.558-1.387.585-4.6.211-9.262-.862-13.814.549a1.356,1.356,0,0,1-1.25-.118c-.842-.528-2.059-.256-2.69-1.24a177.619,177.619,0,0,1,19.141.224",
    transform: "translate(-118.343 -51.496)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28332",
    "data-name": "Path 28332",
    d: "M320.815,140c1.074.373,2.377-.307,3.308.718-2.174,1.334-4.671.938-7.027,1.3-.953-.391-.166-1.222-.453-1.781,1.35-.792,2.775-.277,4.172-.237",
    transform: "translate(-115.914 -51.464)",
    fill: "#ffb100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28333",
    "data-name": "Path 28333",
    d: "M29.479,206.739q.3.011.6.028c3.9-1.937,7.046-4.926,10.5-7.488q6.079-4.515,12.01-9.226a4.893,4.893,0,0,1,6.324-.333c8.6,5.294,17.32,10.4,26.04,15.5a11.8,11.8,0,0,1,2.343,1.6c1.147,1.111.356,1.576-.7,1.943a22.959,22.959,0,0,1-5.035.265c-15.03-.014-30.06.054-45.089-.051-1.795-.013-3.55-.33-5.336-.387-1.088-.034-2.208-.25-1.653-1.844",
    transform: "translate(-10.739 -69.475)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28334",
    "data-name": "Path 28334",
    d: "M88.269,146.706c-10.083-6.043-20.19-12.046-30.225-18.167-1.785-1.088-2.958-.342-4.232.634q-10.231,7.849-20.444,15.719c-.844.648-1.561,2-2.861.627l.023-1.916c.387-2.725,2.678-5.3.649-8.216,1.34.141,1.673-.538,1.964-1.791Q43.409,89.436,53.794,45.306c1.6-6.822,3.107-13.663,4.633-20.5.318-1.425.67-2.725,2.582-2.412,3,11.793,5.591,23.68,8.35,35.529,4.948,21.25,10.129,42.446,14.931,63.731,1.5,6.65,3.346,13.233,4.718,19.911.591,2.877,1.985,3.7,4.764,3.686,16.24-.087,32.48-.058,48.72-.023,1.638,0,3.415-.388,4.8.99a.925.925,0,0,1-.528.977,10.234,10.234,0,0,1-4.666.581q-24.363.022-48.725-.012c-1.746,0-3.63.378-5.1-1.057",
    transform: "translate(-11.169 -8.226)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28335",
    "data-name": "Path 28335",
    d: "M84.675,218.423l58.872.031c1.589.9,1.718,2.268,1.249,3.832-1.876-.006-3.753-.016-5.63-.016q-24.5-.006-48.993,0c-12.308.018-24.611-.488-36.9-.836-9.905-.281-19.9-.451-29.731-2.266a3.745,3.745,0,0,1-2.847-1.515,15.945,15.945,0,0,1,5.625-.445c.219,1.554,1.429,1.266,2.439,1.266q27.96-.015,55.92-.051",
    transform: "translate(-7.575 -79.944)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28336",
    "data-name": "Path 28336",
    d: "M308.81,220.75c2.3-1.169,4.84-.874,7.137-.523,5.986.914,11.97.423,17.948.485,12.778.133,25.557.093,38.336.125.075,1.966-1.243,3.35-2.076,4.937-1.9,1.881-4.39,1.131-6.565,1.221-18.015.745-36.042.261-54.065.38a6.848,6.848,0,0,1-3.4-.5c-1-2.861,1.186-4.343,2.683-6.123",
    transform: "translate(-111.984 -80.958)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28337",
    "data-name": "Path 28337",
    d: "M215.409,217.568l-1.249-3.832a.885.885,0,0,0-.055-.61c-1.287-2.052.047-3.775.7-5.586a5.315,5.315,0,0,1,3.92-3.173l3.7-.025c3.758,1.451,5.431,4.735,5.009,9.817a10.252,10.252,0,0,1-5.044,7.467c-2.238.165-4.357.025-5.65-2.212l-1.325-1.847",
    transform: "translate(-78.189 -75.225)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28338",
    "data-name": "Path 28338",
    d: "M294.054,228.817c.919,1.1,2.17.58,3.258.582,18.97.039,37.94.023,56.91.057a10.826,10.826,0,0,0,4.3-.757l1.421.729c-3.751,2.425-69.027,2.7-85.838.162,4.974-1.439,9.336-1.11,13.6-1.54,2.221-.6,4.244.416,6.349.766",
    transform: "translate(-100.353 -83.885)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28339",
    "data-name": "Path 28339",
    d: "M227.569,226.486a14.2,14.2,0,0,0,4.392-6.639c1.9-1.026,3.9-.185,5.853-.286,3.233-.169,6.482.134,9.713-.281,1.142-.147,2.324-.263,3.126.878a1.825,1.825,0,0,1-.4,2.169l-1.854,2.533a3.3,3.3,0,0,1-3.247,2.107c-5.478.255-10.961.2-16.442.036a2.244,2.244,0,0,1-1.138-.517",
    transform: "translate(-83.315 -80.691)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28340",
    "data-name": "Path 28340",
    d: "M222.2,229.789c5.157-.073,10.313-.2,15.469-.189a8.366,8.366,0,0,0,5.359-1.437c1.27.842,2.989.3,4.9,1.971a124.533,124.533,0,0,1-35.02.289c.756-2.351,2.847-.914,3.581-2.238a9.768,9.768,0,0,0,5.708,1.6",
    transform: "translate(-77.951 -83.995)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28341",
    "data-name": "Path 28341",
    d: "M299.6,225.447c-2.309,1.328-4.247-.4-6.35-.766l-3.953-2.5c-.209-1.2.566-2.024,1.1-2.948a1.748,1.748,0,0,1,1.319-.522c3.643-.021,7.275.314,10.917.334q.047.631.093,1.262c-.76,1.884-1.174,3.977-3.126,5.141",
    transform: "translate(-105.904 -80.514)",
    fill: "#dbe4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28342",
    "data-name": "Path 28342",
    d: "M263.35,221.644q.077-.894.153-1.788c.271-.546.051-1.309.74-1.673,1.974-.643,4.052-.55,6.077-.847a4.055,4.055,0,0,1,.92.194c2.143,1.591,5.4,1.338,6.85,4.084l-14.74.03",
    transform: "translate(-96.415 -80.009)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28343",
    "data-name": "Path 28343",
    d: "M282.6,221.639c-2.115-1.573-4.918-1.826-6.929-3.6,3.557-1.377,6.826-.31,10.045,1.178.221,1.207-.782,1.734-1.391,2.479l-1.724-.059",
    transform: "translate(-100.926 -80.034)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28344",
    "data-name": "Path 28344",
    d: "M303.386,213.985a19.266,19.266,0,0,1-11.407-.071,2.453,2.453,0,0,1-.667-1.854,2,2,0,0,1,2-2.277c-2.134-1.066-.731-2.128,0-3.2,1.283-1.067,2.614-2,4.429-1.458l2.622.6c2.749,2.117,3.321,5.028,3.027,8.254",
    transform: "translate(-106.652 -75.457)",
    fill: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28345",
    "data-name": "Path 28345",
    d: "M165.616,140.45q-.621,2.84-1.241,5.68c-18.261,0-36.522-.059-54.782.083-2.546.02-3.458-.859-3.983-3.12-4.752-20.5-9.6-40.973-14.363-61.469q-6.29-27.079-12.439-54.189c-.375-1.644-1.89-3.209-.51-5.04,1.14.219,2.69-.7,3.244,1.153q-.086.63-.172,1.263c-.917,3.363.667,6.407,1.384,9.51q10.921,47.251,22.13,94.435a53.348,53.348,0,0,0,1.343,5.494c1.547,4.372,2.738,5.261,7.418,5.268q22.308.034,44.615.009c1.371,0,2.743-.032,4.113.019,1.146.044,2.349-.057,3.244.9",
    transform: "translate(-28.457 -8.229)",
    fill: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28346",
    "data-name": "Path 28346",
    d: "M187.3,146.3c1.157,0,2.314-.021,3.47.006a2.576,2.576,0,0,1,2.669,2.2c.563,2.436.982,4.915,1.713,7.3.572,1.865-.255,2.5-1.817,2.821a6.484,6.484,0,0,1-.93.039c-9.913.526-8.529.6-10.8-8.61-.723-2.927.055-3.707,3.175-3.759.841-.014,1.682,0,2.523,0Z",
    transform: "translate(-66.393 -53.854)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28347",
    "data-name": "Path 28347",
    d: "M271.973,158.877c-2.29-.28-4.679.519-6.887-.637q-1.18-4.234-2.36-8.468c-.662-2.39.068-3.561,2.744-3.521,9.985.15,8.314-1.124,10.677,8.239.635,2.514.506,4.2-2.766,3.846-.445-.048-.938.349-1.409.54",
    transform: "translate(-96.103 -53.84)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28348",
    "data-name": "Path 28348",
    d: "M221.736,158.748l-5.609.009a1.977,1.977,0,0,0-.236-.208c-1.556-1-4.168.64-4.95-1.128a47.8,47.8,0,0,1-2.43-9.029c-.344-1.548.431-2.379,2.109-2.23.627.056,1.273-.071,1.892.016,2.433.344,5.549-1.254,7.191.979,2.1,2.862,2.144,6.666,2.627,10.164.06.44-.384.95-.595,1.427",
    transform: "translate(-76.309 -53.727)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28349",
    "data-name": "Path 28349",
    d: "M302.845,158.784l-10.68-.627c-.746-3.133-1.422-6.284-2.264-9.39-.513-1.891.29-2.416,1.99-2.578,8.764-.836,11.5,1.583,11.862,10.391.043,1.02-.57,1.49-.907,2.2",
    transform: "translate(-106.08 -53.76)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28350",
    "data-name": "Path 28350",
    d: "M249.438,158.166a29.32,29.32,0,0,1-11.376-.018c-.832-3.022-1.737-6.025-2.472-9.07-.477-1.976.427-2.812,2.524-2.92,9.162-.466,9.162-.516,10.775,8.615.2,1.128.367,2.261.55,3.392",
    transform: "translate(-86.206 -53.747)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28351",
    "data-name": "Path 28351",
    d: "M159.933,146.294c6.137,0,6.22.068,7.311,6.044.075.411.126.827.222,1.233,1.266,5.325,1.1,5.864-4.452,5.191-7.179-.869-6.265.785-7.816-6.719-1.184-5.731-1.095-5.749,4.734-5.75",
    transform: "translate(-56.6 -53.856)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28352",
    "data-name": "Path 28352",
    d: "M236.024,119.549c.728-.061,1.387-.221,1.551-1.084,1.175-.618,1.969.1,2.807.763a11.188,11.188,0,0,1,4.089,7.56,5.484,5.484,0,0,1-5.3,6.15,9.247,9.247,0,0,1-9.182-4.887,34.446,34.446,0,0,1-1.167-5.2c.657-3.088,1.988-3.978,4.885-3.411.741.145,1.513.877,2.313.1",
    transform: "translate(-83.776 -43.524)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28353",
    "data-name": "Path 28353",
    d: "M120.43,93.156a22.716,22.716,0,0,0,2.532-.01c2.259-.243,3.557.514,3.907,2.946.328,2.28,1.04,4.5,1.556,6.759.351,1.532-.072,2.5-1.87,2.356a2.411,2.411,0,0,0-.317,0c-9.355.493-9.29.478-11.466-8.6-.638-2.663-.061-3.823,2.808-3.47a24.321,24.321,0,0,0,2.849.023",
    transform: "translate(-41.934 -34.263)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28354",
    "data-name": "Path 28354",
    d: "M141.272,185.288a20.254,20.254,0,0,0-2.517.02c-2.311.3-3.528-.662-3.935-2.946-.4-2.263-.93-4.508-1.521-6.73-.5-1.887.25-2.531,2.037-2.4.209.016.42,0,.629,0,9.439-.154,10.165.514,11.235,9.962.172,1.522-.311,2.153-1.835,2.1-1.363-.048-2.728-.01-4.093-.008",
    transform: "translate(-48.746 -63.767)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28355",
    "data-name": "Path 28355",
    d: "M285.41,105.252h-.316c-5.536,0-5.72.032-6.746-5.344-1.352-7.09-2.484-6.715,5.211-6.677,5.295.027,5.3.005,6.575,5.252.049.2.076.414.132.616,1.99,7.172,1.689,6.1-4.856,6.152",
    transform: "translate(-101.549 -34.316)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28356",
    "data-name": "Path 28356",
    d: "M204.234,105.258c-1.26,0-2.52,0-3.781-.006a2.56,2.56,0,0,1-2.767-2.07c-.574-2.535-.946-5.118-1.6-7.63-.476-1.839.387-2.271,1.9-2.292,1.47-.021,2.941-.01,4.411-.011,5.32,0,5.453.106,6.508,5.357.061.306.038.629.094.936,1.035,5.721,1.036,5.72-4.769,5.716",
    transform: "translate(-71.742 -34.327)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28357",
    "data-name": "Path 28357",
    d: "M224.673,78.3c-1.265,0-2.53-.042-3.793.011a2.065,2.065,0,0,1-2.237-1.8c-.659-2.635-1.218-5.294-1.842-7.937-.36-1.526.362-2.215,1.784-2.242,2.633-.049,5.268,0,7.9-.028a2.4,2.4,0,0,1,2.458,2.04c.606,2.32,1.1,4.673,1.55,7.028.4,2.081-.306,3.233-2.664,2.959a27.56,27.56,0,0,0-3.159-.02Z",
    transform: "translate(-79.34 -24.411)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28358",
    "data-name": "Path 28358",
    d: "M208.164,120.2c6.888.046,5.544-.668,7.049,5.579,1.751,7.269,1.98,6.378-4.972,6.423-5.771.038-5.771.011-6.986-5.552-.022-.1-.042-.205-.058-.309-.94-6.244-2.307-6.242,4.967-6.141",
    transform: "translate(-74.115 -44.241)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28359",
    "data-name": "Path 28359",
    d: "M256.223,93.241c6.5.155,5.24-1.164,7,5.665,1.627,6.328,1.556,6.346-4.978,6.352-5.675,0-5.675,0-6.9-5.517-.045-.2-.08-.411-.119-.617-1.118-5.879-1.118-5.879,5-5.882",
    transform: "translate(-91.766 -34.322)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28360",
    "data-name": "Path 28360",
    d: "M171.189,78.316c-.21,0-.421,0-.631,0-6.092-.114-5.256.9-6.511-5.332-1.347-6.683-1.333-6.686,5.65-6.678,4.916.006,4.923.013,5.815,4.854.075.411.15.822.248,1.228,1.429,5.93,1.43,5.93-4.57,5.928",
    transform: "translate(-59.805 -24.409)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28361",
    "data-name": "Path 28361",
    d: "M197.831,78.283c-7-.083-5.522.734-7.081-5.866-1.776-7.519-.936-6.044,4.829-6.129,5.586-.082,5.586-.018,6.963,5.324.026.1.081.2.108.3,1.656,6.376,1.656,6.376-4.819,6.375",
    transform: "translate(-69.532 -24.379)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28362",
    "data-name": "Path 28362",
    d: "M252.177,78.314c-6.6-.122-5.669,1.1-7.15-6.123-1.206-5.883-1.195-5.885,4.646-5.89,5.989-.005,6.039-.017,7.39,5.884,1.549,6.762,2.387,6.072-4.887,6.129",
    transform: "translate(-89.475 -24.408)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28363",
    "data-name": "Path 28363",
    d: "M174.6,93.222a27.673,27.673,0,0,0,2.833-.016c2.037-.21,3.145.641,3.535,2.644.437,2.248,1.049,4.462,1.49,6.709.342,1.743-.167,2.905-2.268,2.685-.519-.054-1.055.042-1.573-.015-2.454-.269-5.663,1.18-7.216-.715-2.149-2.622-1.928-6.485-2.751-9.807-.254-1.022.545-1.473,1.541-1.47,1.469,0,2.939,0,4.409,0v-.015",
    transform: "translate(-61.726 -34.301)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28364",
    "data-name": "Path 28364",
    d: "M168.775,185.264c-5.769,0-5.769,0-7.214-5.587-1.66-6.417-1.66-6.417,5.036-6.422,5.825,0,5.825,0,6.678,5.638.031.208.044.42.087.624,1.2,5.746,1.2,5.746-4.587,5.746",
    transform: "translate(-58.812 -63.782)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28365",
    "data-name": "Path 28365",
    d: "M279.328,78.3c-6.078.006-6.078.006-7.145-6-.018-.1-.009-.21-.028-.312-1.057-5.7-1.057-5.742,4.72-5.691,6.212.055,5.69-.969,7.207,5.5.024.1.041.205.064.308,1.514,6.864,2.39,6.128-4.818,6.2",
    transform: "translate(-99.442 -24.396)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28366",
    "data-name": "Path 28366",
    d: "M227.364,105.293c-1.263-.1-1.783-.908-2.049-2.043-.333-1.424-.852-2.809-1.121-4.242-1.085-5.773-1.06-5.812,4.719-5.769,6.039.044,5.711-1.086,7.344,5.869.382,1.63.821,3.247,1.234,4.869a2.039,2.039,0,0,1-2.06,2.011c-2.712.171-5.476.644-8.067-.7",
    transform: "translate(-81.878 -34.309)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28367",
    "data-name": "Path 28367",
    d: "M143.719,78.311c-6.686-.05-5.65.669-7.08-5.52-1.5-6.51-1.557-6.5,5.105-6.495,5.533,0,5.532,0,6.647,5.483.041.2.116.4.163.6,1.363,5.921,1.363,5.921-4.835,5.928",
    transform: "translate(-49.722 -24.406)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28368",
    "data-name": "Path 28368",
    d: "M289.562,120.21c5.5,0,5.5,0,6.869,5.38,1.684,6.63,1.684,6.63-5.219,6.629-5.246,0-5.245,0-6.48-5.008a5.6,5.6,0,0,1-.186-.6c-.908-7.119-2.814-6.352,5.016-6.4",
    transform: "translate(-103.852 -44.253)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28369",
    "data-name": "Path 28369",
    d: "M180.741,120.211c6.157,0,6.156,0,7.486,6.261.065.306.219.593.29.9,1.062,4.586.856,4.841-3.787,4.85-8.447.016-7.129.309-8.762-6.914-1.156-5.112-1.228-5.1,4.774-5.1",
    transform: "translate(-64.199 -44.254)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28370",
    "data-name": "Path 28370",
    d: "M156.373,132.2c-1.155,0-2.317.083-3.462-.019-1.8-.16-3.133-.755-3.373-2.951a42.925,42.925,0,0,0-1.431-6.714c-.5-1.816.35-2.273,1.88-2.307.315-.007.63-.012.945-.006,11.336.239,7.648-1.843,10.677,8.811.694,2.443-.064,3.574-2.719,3.217a19,19,0,0,0-2.517-.018Z",
    transform: "translate(-54.171 -44.242)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28371",
    "data-name": "Path 28371",
    d: "M195.821,185.262c-5.674,0-5.674,0-6.94-5.7-1.4-6.32-1.4-6.307,4.813-6.312,6.62-.006,5.521-.068,6.959,5.477.026.1.088.195.1.3.983,6.389,2.8,6.326-4.936,6.243",
    transform: "translate(-68.874 -63.778)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28372",
    "data-name": "Path 28372",
    d: "M262.764,120.211c5.48.008,5.48.008,6.683,5.706,1.331,6.3,1.331,6.3-5.2,6.3-6.175.007-4.849.347-6.331-4.991-.056-.2-.059-.417-.11-.62-1.61-6.408-1.611-6.408,4.954-6.4",
    transform: "translate(-94.061 -44.253)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28373",
    "data-name": "Path 28373",
    d: "M149.805,105.143c-1.158,0-2.317,0-3.475,0-.77,0-1.622-.113-1.966-.789a30.448,30.448,0,0,1-2.616-9.876c-.09-.658.591-1.082,1.235-1.244a6.993,6.993,0,0,1,1.256-.1c8.854-.543,8.854-.543,10.936,8.072.88,3.64.648,3.93-3.159,3.94-.737,0-1.474,0-2.212,0Z",
    transform: "translate(-51.893 -34.216)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28374",
    "data-name": "Path 28374",
    d: "M123.092,130.928q-1.167-4.376-2.335-8.751c-.385-1.431.042-2.239,1.637-2.216.945.013,1.891-.005,2.836-.006,7.728,0,7.728,0,8.736,7.731-.281,3.8-.281,3.811-3.978,3.824a21.43,21.43,0,0,1-6.9-.583",
    transform: "translate(-44.162 -44.16)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28375",
    "data-name": "Path 28375",
    d: "M139.2,148.392c.7,2.73,1.359,5.469,2.1,8.188.486,1.789-.373,2.272-1.949,2.234-1.261-.029-2.524,0-3.786,0-6.381.01-6.381.01-7.144-6.52a2.383,2.383,0,0,0,.23-1.813c-1.464-3.051.3-3.289,2.656-3.248,2.691.046,5.383-.045,7.9,1.16",
    transform: "translate(-46.902 -54.2)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28376",
    "data-name": "Path 28376",
    d: "M229.661,126.105a9.416,9.416,0,0,0,7.978,4.285c3.763.066,5.844-2.44,5.039-6.139-.751-3.449-2.508-6.189-5.926-7.6-2.281-1.707-5.368-.492-7.678-2.1,2.816-2.038,6.36-1.587,10.113,1.286,2.765,2.36,5.041,5.006,5.569,8.8.655,4.7-2.255,8.04-7.018,7.867a11.55,11.55,0,0,1-9.922-5.716c-1.733-2.8-1.615-6.541.184-8.566,2.229-2.51,4.719-1.525,7.2-.485.134,2-.965.9-1.69.654-2.5-.844-4.38-.459-5,2.469a17.787,17.787,0,0,0,1.149,5.25",
    transform: "translate(-82.954 -41.707)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28377",
    "data-name": "Path 28377",
    d: "M317.379,142.514c2-2.264,4.669-.948,7.027-1.3l.631.64c.524,3.746,1.188,7.452,3.186,10.764-2.932-.131-5.99,1.173-8.76-.771q-1.041-4.666-2.083-9.333",
    transform: "translate(-116.196 -51.961)",
    fill: "#ffb100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28378",
    "data-name": "Path 28378",
    d: "M138.925,59.185c-1.568,0-3.136.013-4.7-.006-.647-.008-1.344-.14-1.374-.936-.03-.825.669-.956,1.317-.96q4.547-.026,9.094-.013c.778,0,1.651.214,1.7,1.039.061,1.062-.96.865-1.642.882-1.462.035-2.927.011-4.39.011v-.017",
    transform: "translate(-48.636 -21.082)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28379",
    "data-name": "Path 28379",
    d: "M247.836,57.266c1.359,0,2.719-.023,4.077.007.722.016,1.6-.006,1.517,1.068-.065.823-.807.826-1.432.845-2.92.09-5.839.2-8.758.227-.728.006-1.527-.265-1.488-1.234.034-.833.745-.9,1.379-.9,1.568-.02,3.136-.007,4.7-.008",
    transform: "translate(-88.507 -21.078)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28380",
    "data-name": "Path 28380",
    d: "M193.659,59.191c-1.678,0-3.355.017-5.032-.008-.66-.01-1.334-.243-1.358-.989-.019-.575.557-.879,1.112-.883,3.145-.021,6.291-.034,9.435.01.79.011,1.531.457,1.384,1.341-.174,1.043-1.046.665-1.77.625-1.253-.07-2.513-.02-3.771-.02v-.077",
    transform: "translate(-68.561 -21.091)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28381",
    "data-name": "Path 28381",
    d: "M274.48,59.184c-1.472,0-2.944.016-4.414-.008-.654-.011-1.342-.161-1.3-.993s.747-.9,1.391-.906q4.415-.016,8.83,0c.638,0,1.384.06,1.449.858.086,1.08-.82,1.04-1.538,1.056-1.471.032-2.943.009-4.415.009v-.02",
    transform: "translate(-98.396 -21.083)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28382",
    "data-name": "Path 28382",
    d: "M220.821,57.278c1.469,0,2.939-.022,4.407.01.667.014,1.281.234,1.189,1.079-.07.648-.616.808-1.154.811q-4.565.026-9.131,0c-.657,0-1.349-.149-1.367-.947-.018-.814.673-.957,1.332-.963,1.575-.015,3.149-.005,4.723-.005v.011",
    transform: "translate(-78.628 -21.081)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28383",
    "data-name": "Path 28383",
    d: "M111.866,59.267c-1.673,0-3.348.05-5.017-.024a1.066,1.066,0,0,1-1.033-1.292c.068-.7.635-.768,1.144-.77q4.709-.018,9.419.021c.666,0,1.254.2,1.325,1,.1,1.092-.688,1.118-1.443,1.125-1.466.014-2.93,0-4.4,0v-.066",
    transform: "translate(-38.737 -21.049)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28384",
    "data-name": "Path 28384",
    d: "M166.066,59.177c-1.573,0-3.147.027-4.719-.015a1.034,1.034,0,0,1-1.106-.914.985.985,0,0,1,1.08-.919q4.719-.04,9.439.008a1.113,1.113,0,0,1,1.168,1.209c-.059.943-.906.646-1.455.663-1.467.045-2.937.015-4.406.015v-.048",
    transform: "translate(-58.666 -21.098)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28385",
    "data-name": "Path 28385",
    d: "M240.261,114.719c-3.282-1.122-6.527-2.54-10.113-1.286l-.635-1.858c2.283-.017,4.568-.09,6.849-.031a3.493,3.493,0,0,0,3.278-1.285c.085.056.24.106.245.17.135,1.429.254,2.859.376,4.29",
    transform: "translate(-84.027 -40.59)",
    fill: "#f6f9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28386",
    "data-name": "Path 28386",
    d: "M124.517,135.433c.107-.679-.2-1.693.8-1.792,1.357-.135-.11.88.4,1.238,1.347.952,2.862.288,4.276.52,2.722.447,4.822-.094,5.4-3.207,1.3,4.107,1.144,4.526-2.9,4.269-2.657-.169-5.58,1.226-7.975-1.028",
    transform: "translate(-45.587 -48.665)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28387",
    "data-name": "Path 28387",
    d: "M138.766,148.185c-.283.384.047,1.7-.5,1.2-2.766-2.543-6.052-1.444-9.137-1.635-.834-.052-1.021.511-.472,1.233.967,1.272.671,2.311-.671,3.107-.712-1.616-1.589-3.213-.617-5.034a36.416,36.416,0,0,1,10.5-.01l.9,1.143",
    transform: "translate(-46.473 -53.993)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28388",
    "data-name": "Path 28388",
    d: "M244.383,201.283l1.451,1.054H228.569l-.009-.447c3.959,0,7.917.031,11.876-.02,1.108-.014,2.343.422,3.285-.593l.663.006",
    transform: "translate(-83.678 -74.097)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28389",
    "data-name": "Path 28389",
    d: "M138.118,146.892l-10.5.01a21.915,21.915,0,0,1,10.5-.01",
    transform: "translate(-46.722 -53.843)",
    fill: "#fc554d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28390",
    "data-name": "Path 28390",
    d: "M222.215,49.605H100.552c2.569-1.345,5.32-.417,7.98-.6,2.4-.161,4.819-.035,7.229-.037.988-.554,2.066-.291,3.1-.292q50.093-.023,100.185.044c1.018,0,2.581-1,3.169.881",
    transform: "translate(-36.813 -17.839)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28391",
    "data-name": "Path 28391",
    d: "M231,49.459c-1.043-1.092-2.392-.608-3.6-.609q-51.428-.042-102.856-.024c.936-1.034,2.177-.611,3.285-.612q50.514-.033,101.028.02c1.18,0,2.889-.856,3.4,1.225H231",
    transform: "translate(-45.598 -17.693)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28392",
    "data-name": "Path 28392",
    d: "M241.352,16.249l.6,1.172c-.771,1.658-.574,3.684-1.951,5.112-1.9,1.426-3.811,2.571-5.872.251-.033-.672.238-1.06.963-1.023a5.3,5.3,0,0,0,1.784-4.22c.9-.115.975.473.988,1.132.025,1.352,1.12.521,1.674.8.97.485.936-.409,1.114-.9.274-.759.472-1.545.7-2.32",
    transform: "translate(-85.715 -5.982)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28393",
    "data-name": "Path 28393",
    d: "M128.911,26.313c1.948,1.13,3.876.521,5.8-.068-.382.615-.795,1.214-1.141,1.848-.7,1.291-1.653,2.357-3.232,1.934a3.2,3.2,0,0,1-2.631-3.144c.26-.483.467-1.075,1.2-.571",
    transform: "translate(-46.757 -9.616)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28394",
    "data-name": "Path 28394",
    d: "M259.95,26.411c1.91,1.141,3.813.545,5.717-.022-.407,1.649-1.69,2.587-2.985,3.428-1.273.826-2.288.293-3.2-.844s-1.17-1.973.468-2.562",
    transform: "translate(-94.734 -9.715)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28395",
    "data-name": "Path 28395",
    d: "M233.723,26.177c1.894,1.529,3.778.428,5.664-.023L238.2,28.113c-.745.762-1.1,2-2.472,1.994-2.077-.147-3.431-1-3.259-3.332.381-.275.576-.938,1.253-.6",
    transform: "translate(-85.105 -9.602)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28396",
    "data-name": "Path 28396",
    d: "M155.749,26.215c1.886,1.394,3.751.444,5.621-.049-.074,1.224-1.449,1.534-1.808,2.558-.5.607-.787,1.486-1.805,1.461-1.987-.272-3.471-1.029-3.286-3.392.394-.263.577-.991,1.279-.578",
    transform: "translate(-56.547 -9.605)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28397",
    "data-name": "Path 28397",
    d: "M237.62,31.29l2.472-1.994c-.225,1.4-.572,2.656-2.472,1.994",
    transform: "translate(-86.995 -10.785)",
    fill: "#89302d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28398",
    "data-name": "Path 28398",
    d: "M155.757,25.274l-1.279.578c-.058-1.756,1.151-2.134,2.537-2.316l-1.258,1.739",
    transform: "translate(-56.556 -8.664)",
    fill: "#761b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28399",
    "data-name": "Path 28399",
    d: "M128.909,25.665l-1.2.571c-.048-1.295.5-1.99,1.875-1.86a1.405,1.405,0,0,1-.674,1.289",
    transform: "translate(-46.754 -8.968)",
    fill: "#822224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28400",
    "data-name": "Path 28400",
    d: "M233.732,25.561l-1.253.6c.177-1.168.333-2.367,2.007-1.393l-.754.794",
    transform: "translate(-85.113 -8.986)",
    fill: "#7b0e11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28401",
    "data-name": "Path 28401",
    d: "M159.663,31.718l1.806-1.462c-.077,1.132-.311,2.071-1.806,1.462",
    transform: "translate(-58.454 -11.138)",
    fill: "#8c292a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28402",
    "data-name": "Path 28402",
    d: "M167.1,141.882q-25.782,0-51.564-.006c-6.163,0-7.689-1.169-9.12-7.215q-4.453-18.813-8.821-37.646Q89.8,63.647,81.993,30.283c-.369-1.568-.344-2.887.86-4.041l4.507,17.7c.517,5.133,2.255,9.993,3.419,14.98,4.873,20.866,9.943,41.688,14.688,62.582.806,3.55,1.673,7.119,2.283,10.735.8,4.74,3.159,6.482,8.006,6.482q24.066,0,48.131,0c2.2,0,4.392.049,6.588.076a13.576,13.576,0,0,0-3.374,3.08",
    transform: "translate(-29.942 -9.661)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28403",
    "data-name": "Path 28403",
    d: "M251.049,213.654l-.659,1.419c-.864-1.025-1.853-.377-2.868-.32-5.2.29-10.409.766-15.575-.372.085-4.027-.883-7.593-4.414-10.04l18.85.032c2.7.3,3.564,2.469,4.6,4.472.644,1.594,1.25,3.19.067,4.808",
    transform: "translate(-83.303 -75.225)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28404",
    "data-name": "Path 28404",
    d: "M261.152,208.715c-1.067-1.657-1.914-3.509-3.88-4.375q13-.042,26-.084c.727,0,1.48-.071,2,.607a8.29,8.29,0,0,0-3.79,1.863,11.514,11.514,0,0,1-6.532,1.641c-4.6.036-9.215-.258-13.8.348",
    transform: "translate(-94.19 -75.193)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28405",
    "data-name": "Path 28405",
    d: "M60.189,129.035c-2.4-1.571-3.973.267-5.557,1.487-6.321,4.869-12.565,9.835-18.854,14.744a23.924,23.924,0,0,1-2.357,1.379C42.47,107.81,51.413,69.43,60.355,31.05l.5-.108c.777,3.038,1.611,6.064,2.321,9.118C66.665,55.048,70.1,70.049,73.591,85.037c3.111,13.355,6.173,26.723,9.5,40.024.612,2.446.036,3.4-2.106,3.974a3.571,3.571,0,0,1-2.87,1q-7.531.139-15.062,0a3.537,3.537,0,0,1-2.868-1",
    transform: "translate(-12.236 -11.391)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28406",
    "data-name": "Path 28406",
    d: "M74.42,186.162h20.8c2.573-.262,3.6.755,3.964,3.461.574,4.208,1.819,8.326,2.8,12.477a1.541,1.541,0,0,1-.347,1.7L72.291,186.462l2.129-.3",
    transform: "translate(-26.466 -68.518)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28407",
    "data-name": "Path 28407",
    d: "M286,214.23q-.015.844-.03,1.69l-.536.728-10.045-1.178q-.2-.017-.411-.017c-.409-1.505.716-2.04,1.71-2.607a34.989,34.989,0,0,1,3.752-1.628c3.678-1.561,4.748-.967,5.559,3.012",
    transform: "translate(-100.639 -77.463)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28408",
    "data-name": "Path 28408",
    d: "M281.787,213.4c-1.656-3.77-1.921-3.949-5.7-2.072-1.855.922-4.321.971-5.322,3.294l-6.589.44q-.393-2.453-.785-4.906c.238-1.788,1.646-1.29,2.7-1.3,3.9-.044,7.808-.094,11.707.014a25.241,25.241,0,0,0,5.924-.7c-.317.833-2.42,1.442-.324,2.586.15.082.237.277.354.419-.3.084-.593.194-.9.248-1.2.214-.949,1.194-1.072,1.979",
    transform: "translate(-96.431 -76.634)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28409",
    "data-name": "Path 28409",
    d: "M230.644,130.512a5.519,5.519,0,0,1-1.149-5.25,15.02,15.02,0,0,1,1.149,5.25",
    transform: "translate(-83.937 -46.113)",
    fill: "#edefe8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllAgendaWeb);
export default __webpack_public_path__ + "static/media/IllAgendaWeb.6fe76bb6c52e25504d35a8de9faca79d.svg";
export { ForwardRef as ReactComponent };